export const REQ_CATA_NOVELTIES_SUCCESS = "REQ_CATA_NOVELTIES_SUCCESS"

export const REQ_CATA_WASTE_SUCCESS = "REQ_CATA_WASTE_SUCCESS"

export const REQ_CATA_RECORDS_SUCCESS = "REQ_CATA_RECORDS_SUCCESS"

export const REQ_CATA_MOVEMENTS_SUCCESS = "REQ_CATA_MOVEMENTS_SUCCESS"